import Vue from 'vue';
import IApiError from './models/IApiError';
import { ModelStateError } from './services/BaseService';

class AppEvents extends Vue {
  public static APP_LOGOUT = 'APP_LOGOUT';
  public static APP_LOGIN_SUCCESS = 'APP_LOGIN_SUCCESS';
  public static APP_API_UNAUTHORIZED = 'APP_API_UNAUTHORIZED';

  private static trimDots(sourceText: string){
    return sourceText.replace(/^\.+/, '').replace(/\.+$/, '');
  }

  static handleApiError(e: any){
    let error: string | Error | ModelStateError;
    if (!e){
      throw new Error(Vue.i18n.translate(
        "generic.error.api.request-error", 
        "An error occurred during the processing of the request. Please try again later or contact support.")
      );
    }

    if (!e.response) {
      throw e;
    }

    const applicationError = e.response.headers['Application-Error'];
    if (applicationError) {
      throw new Error(applicationError);
    }

    if(!e.response.status || !e.response.data)
    {
      throw e;
    }

    if (e.response.data.toString().startsWith("<!DOCTYPE")){
      throw new Error(Vue.i18n.translate(
        "generic.error.api.server-error", 
        "A server error occurred. Please try again later or contact support.")
      );
    } 

    if (e.response.data && typeof e.response.data !== 'string' && !(e.response.data instanceof String)) {
      let fullErrorMessage: any = '';
      let apiErrors: IApiError[] = [];
      if (e.response.data.title === "One or more validation errors occurred."){
        console.log("Handling validation error ...")
        fullErrorMessage = e.response.data.title;
        const validationErrors = e.response.data.errors;
        apiErrors.push({ code: "validation.failed", message: e.response.data.title });
        for (let property of Object.keys(validationErrors)){
          console.log(property);
          apiErrors.push({ code: "validation.properties." + this.trimDots(property), message: property });
          for(let propertyError of validationErrors[property]){
            apiErrors.push({ code: "validation.errors." + this.trimDots(propertyError), message: propertyError });
          }
        }
      } else {
        for (let code in e.response.data) {
          let message = e.response.data[code];
          if (message instanceof Array){
            message = message.join(" ");
          }
         
          apiErrors.push({ code: this.trimDots(code), message });
          if (message) {
            fullErrorMessage += message + '\n';
          }
        }
      }
      error = new ModelStateError(fullErrorMessage, apiErrors);
    } else {
      throw new Error(this.trimDots(e.response.data));
    }
    throw error;
  }

  static getApiErrorsFromError(e: unknown): IApiError[] {
    if ((e as ModelStateError).type == ModelStateError.TypeName){
      const modelStateError = e as ModelStateError;
      return modelStateError.apiErrors;
    } 
    let message = (e as Error).message;
    if (!message){
      message = e.toString();
    }
    return [
      {
        code: message, 
        message: message
      }
    ];
  }
}

export default AppEvents;
